import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useEventContent } from "../../context/EventContentContext";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { CopyText } from "../CopyText";
import { getAtPath } from "../../lib/siteCopyPaths";
import { formatHomeFeatureNightTitle } from "../../lib/eventDisplay";

const LINKS = ["/event", "/dorothy", "/live", "/gallery"] as const;

export function HomeFeatures() {
  const content = useEventContent();
  const { copy } = useSiteCopy();
  const rows = copy.home.features.rows;

  const nightTitle = useMemo(
    () => formatHomeFeatureNightTitle(content.date),
    [content.date],
  );

  return (
    <section className="section home-features">
      <div className="sec-eyebrow center">
        <em>
          <CopyText path="home.features.sectionEyebrow" as="span" />
        </em>
      </div>
      <h2 className="sec-title sec-title-sm center">
        <CopyText path="home.features.sectionTitle" as="span" />
      </h2>
      <div className="home-features-grid">
        {rows.map((_, i) => (
          <Link key={LINKS[i]} to={LINKS[i]} className="home-feature">
            <div className="home-feature-eyebrow">
              {String(getAtPath(copy, `home.features.rows.${i}.eyebrow`) ?? "")}
            </div>
            <h3 className="home-feature-title">
              {i === 0 ? nightTitle : String(getAtPath(copy, `home.features.rows.${i}.title`) ?? "")}
            </h3>
            <p className="home-feature-body">
              {String(getAtPath(copy, `home.features.rows.${i}.body`) ?? "")}
            </p>
            <span className="home-feature-cta">
              {String(getAtPath(copy, `home.features.rows.${i}.cta`) ?? "")}{" "}
              <span className="arr">→</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
